import React from 'react';
import { observer } from 'mobx-react-lite';
import { BetResponseCode, gameConfigStore, isMobile, notificationStore } from '@pascal/pascal-core';
import { AdditionalInputValueChangingButtons } from '@pascal/pascal-core/shared/core/enums/additionalInputValueChangingButtons';

import {
  minOdd,
  numPadSectionName,
  autoCashOutDataKeys,
  additionalBetAmountChangingButtons,
} from '../../enums/uiConfig';
import { doBetStore } from '../../store';
import { globalTranslationKeys } from '../../enums';
import { decidedCurrentValue } from '../../helpers/supporters';
import { divide, toFixed } from '../../helpers/arithmeticOperations';

export const AutoCashOutSection = observer(
  ({
    t,
    maxWin,
    betAmount,
    autoBetData,
    isAutoCashOut,
    activeFreeBet,
    autoCashOutOdd,
    handleOpenNumPad,
    currentFighterSection,
    handleSwitchAutoCashOut,
    handleChangeAutoCashOutInput,
    handleChangeAutoCashOutInputValue,
  }) => {
    const { typing } = additionalBetAmountChangingButtons;

    return (
      <div
        className={`bet-left-row-cont ${
          autoBetData.isAutoBet || autoBetData.autoBetCount ? 'disabled' : ''
        }`}
      >
        <div className='container-left-circle-text'>
          {!isAutoCashOut ? (
            <p className='bet-left-row-text'>{t(globalTranslationKeys.AutoCashOut)}</p>
          ) : (
            <div className='auto-bet-inp-cont'>
              {/* ADD CLASS " disabled " */}
              <div
                className='auto-bet-inp-around'
                onClick={() =>
                  handleChangeAutoCashOutInput(AdditionalInputValueChangingButtons.minus)
                }
              >
                <i className='ui-lib-minus auto-bet-icon' />
              </div>
              <div className='auto-bet-inp'>
                <input
                  className='input-auto-bet'
                  type='text'
                  readOnly={isMobile()}
                  inputMode={isMobile() ? 'none' : 'text'}
                  autoComplete='off'
                  maxLength={9}
                  value={autoCashOutOdd}
                  onBlur={() => {
                    if (
                      !autoCashOutOdd ||
                      (activeFreeBet?.id && autoCashOutOdd < activeFreeBet?.minOdd) ||
                      autoCashOutOdd < minOdd
                    ) {
                      doBetStore.updateAutoCashOutData(
                        autoCashOutDataKeys.isValidatedOdd,
                        true,
                        currentFighterSection
                      );
                      doBetStore.updateAutoCashOutData(
                        autoCashOutDataKeys.autoCashOutOdd,
                        decidedCurrentValue(
                          !autoCashOutOdd ||
                            (activeFreeBet?.id && autoCashOutOdd < activeFreeBet?.minOdd) ||
                            autoCashOutOdd < minOdd,
                          activeFreeBet?.id ? activeFreeBet?.minOdd : minOdd,
                          activeFreeBet?.id ? activeFreeBet?.minOdd : minOdd,
                          notificationStore.setNotificationType,
                          BetResponseCode.InValidAutoCashOutOdd
                        ),
                        currentFighterSection
                      );
                      doBetStore.updateAutoCashOutData(
                        autoCashOutDataKeys.isBlurred,
                        true,
                        currentFighterSection
                      );
                    }
                    if (autoCashOutOdd > divide(maxWin, betAmount)) {
                      gameConfigStore.setMaxAutoCashOutOdd(toFixed(divide(maxWin, betAmount), 2));
                      doBetStore.updateAutoCashOutData(
                        autoCashOutDataKeys.isValidatedOdd,
                        true,
                        currentFighterSection
                      );
                      doBetStore.updateAutoCashOutData(
                        autoCashOutDataKeys.autoCashOutOdd,
                        decidedCurrentValue(
                          autoCashOutOdd < divide(maxWin, betAmount),
                          toFixed(autoCashOutOdd, 2),
                          toFixed(divide(maxWin, betAmount), 2),
                          notificationStore.setNotificationType,
                          BetResponseCode.InValidMaxAutoCashOutOdd
                        ),
                        currentFighterSection
                      );
                      doBetStore.updateAutoCashOutData(
                        autoCashOutDataKeys.isBlurred,
                        true,
                        currentFighterSection
                      );
                    }
                  }}
                  onChange={(e) => {
                    if (!/^[.,]/.test(e.target.value) && /^\d*[.,]?\d*$/.test(e.target.value)) {
                      handleChangeAutoCashOutInputValue(typing, e.target.value.replace(',', '.'));
                    }
                  }}
                  {...(isMobile()
                    ? { onClick: (e) => handleOpenNumPad(e, numPadSectionName.autoCashOutOdd) }
                    : {})}
                />
              </div>
              {/* ADD CLASS " disabled " */}
              <div
                className='auto-bet-inp-around'
                onClick={() =>
                  handleChangeAutoCashOutInput(AdditionalInputValueChangingButtons.plus)
                }
              >
                <i className='ui-lib-plus auto-bet-icon' />
              </div>
            </div>
          )}
        </div>
        {/* ADD CLASS " active " */}
        <div
          className={`bet-switcher ${isAutoCashOut ? 'active' : ''}`}
          onClick={handleSwitchAutoCashOut}
        >
          <div className='bet-switcher-inner'>
            <div className='circle-bet-switcher-inner'>
              <div className='circle-bet-switcher-inner-bg'>
                <div className='small-circle-center' />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
);
